"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _I18n = _interopRequireDefault(require("I18n"));

var communicationConsentTextKey = 'communicationConsentText';
var communicationConsentCheckboxesKey = 'communicationConsentCheckboxes';
var implicitProcessingConsentTextKey = 'implicitProcessingConsentText';
var explicitProcessingConsentTextKey = 'explicitProcessingConsentText';
var explicitProcessingConsentCheckboxLabelKey = 'explicitProcessingConsentCheckboxLabel';
var privacyPolicyTextKey = 'privacyPolicyText';
var legitimateInterestPrivacyPolicyTextKey = 'legitimateInterestPrivacyPolicyText';

var getText = function getText(consentData, key, locale) {
  return "<p>" + consentData.consentCopy[locale][key] + "</p>" || "Missing data for " + locale + "-" + key;
};

var LegalConsentDefaultSettings =
/*#__PURE__*/
function () {
  function LegalConsentDefaultSettings(consentData, companyName, subscriptions) {
    (0, _classCallCheck2.default)(this, LegalConsentDefaultSettings);
    this.consentData = consentData;
    this.companyName = companyName;
    this.defaultSubscription = subscriptions.find(function (sub) {
      return sub.name === 'One to One';
    }) || subscriptions[0];
  }

  (0, _createClass2.default)(LegalConsentDefaultSettings, [{
    key: "getCommunicationConsentText",
    value: function getCommunicationConsentText(locale) {
      return getText(this.consentData, communicationConsentTextKey, locale);
    }
  }, {
    key: "getCommunicationConsentCheckbox",
    value: function getCommunicationConsentCheckbox(locale) {
      var jsonCheckboxes = this.consentData.consentCopy[locale][communicationConsentCheckboxesKey];
      var checkboxes = JSON.parse(jsonCheckboxes);
      var checkbox = checkboxes[0];

      if (!checkbox.communicationTypeId) {
        checkbox.communicationTypeId = this.defaultSubscription.id;
      }

      checkbox.label = "<p>" + checkbox.label + "</p>";
      return checkbox;
    }
  }, {
    key: "getCommunicationConsentCheckboxDefaultLabel",
    value: function getCommunicationConsentCheckboxDefaultLabel(locale) {
      return "<p>" + _I18n.default.translate('SharedLegalStrings.consent.communicationConsentCheckboxes.label', {
        locale: locale,
        companyName: this.companyName
      }) + "</p>";
    }
  }, {
    key: "getImplicitProcessingConsentText",
    value: function getImplicitProcessingConsentText(locale) {
      return getText(this.consentData, implicitProcessingConsentTextKey, locale);
    }
  }, {
    key: "getExplicitProcessingConsentText",
    value: function getExplicitProcessingConsentText(locale) {
      return getText(this.consentData, explicitProcessingConsentTextKey, locale);
    }
  }, {
    key: "getExplicitProcessingConsentCheckboxLabel",
    value: function getExplicitProcessingConsentCheckboxLabel(locale) {
      return getText(this.consentData, explicitProcessingConsentCheckboxLabelKey, locale);
    }
  }, {
    key: "getPrivacyPolicyText",
    value: function getPrivacyPolicyText(locale) {
      return getText(this.consentData, privacyPolicyTextKey, locale);
    }
  }, {
    key: "getLegitimateInterestPrivacyPolicyText",
    value: function getLegitimateInterestPrivacyPolicyText(locale) {
      return getText(this.consentData, legitimateInterestPrivacyPolicyTextKey, locale);
    }
  }]);
  return LegalConsentDefaultSettings;
}();

exports.default = LegalConsentDefaultSettings;
module.exports = exports.default;